import { Box, Stack, Typography } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { COLORS } from "components/Pricing/constants";

type BulletPreviewProps = {
  items?: string[];
};

export const BulletPreview = ({ items }: BulletPreviewProps) => {
  if (!items || items.length === 0) return null;
  return (
    <Stack spacing={0.6}>
      {items.slice(0, 2).map((line) => (
        <Box
          key={line}
          sx={{
            display: "flex",
            alignItems: "flex-start",
            textAlign: "left",
            gap: 1,
          }}
        >
          <CheckCircleRoundedIcon sx={{ width: 18, color: COLORS.check }} />
          <Typography variant="body2" sx={{ opacity: 0.92 }}>
            {line}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
};
